import React, { ChangeEvent, FC, useCallback, useState } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import debounce from 'lodash/debounce';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';

import { SearchIcon } from 'src/shared/components';
import { useQuery } from 'src/shared/hooks';
import { useTranslate } from 'src/shared/providers';
import { parseQuery } from 'src/shared/utils';

export const MessageCenterListSearch: FC = () => {
  const { t } = useTranslate();
  const query = useQuery();
  const navigate = useNavigate();

  const [inputValue, setInputValue] = useState('');

  const debounceSearchTermChange = useCallback(
    debounce((searchTerm: string, query: URLSearchParams | undefined) => {
      const q = query ? parseQuery<Record<string, any>>(query.toString()) : {};
      const search = qs.stringify({ ...q, searchTerm }, { arrayFormat: 'brackets' });
      navigate({ search });
    }, 500),
    [],
  );

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    debounceSearchTermChange(value, query);
    setInputValue(value);
  };

  return (
    <Stack direction="column" gap={1}>
      <Typography variant="body2" color={(theme) => theme.palette.text.secondary}>
        {t('messageCenter.search')}
      </Typography>
      <TextField
        size="small"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={t('messageCenter.search')}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};
